import { Content, Style, ContentUnorderedList } from 'pdfmake/interfaces'
import { stateFromMarkdown as parse } from 'draft-js-import-markdown'
import { ContentBlock, ContentState } from 'draft-js'
import log from 'loglevel'

function unstyled(block: ContentBlock, tabs?: boolean): Content {
  return tabs
    ? { text: `\t\t\t${block.getText()}`, preserveLeadingSpaces: true }
    : { text: block.getText() }
}

function list(contents: Content[], block: ContentBlock) {
  if (contents.length > 0) {
    const ul = contents[contents.length - 1] as ContentUnorderedList
    if (ul.ul != undefined) {
      ul.ul.push({ text: block.getText() })
    } else {
      contents.push({ ul: [{ text: block.getText() }], style: 'ulist' })
    }
  } else {
    contents.push({ ul: [{ text: block.getText() }], style: 'ulist' })
  }
}

function h1(block: ContentBlock): Content {
  return { text: block.getText(), style: 'heading' }
}

function h2(block: ContentBlock): Content {
  return { text: block.getText(), fontSize: 14, bold: true }
}

function h3(block: ContentBlock): Content {
  return { text: block.getText(), fontSize: 12, bold: true }
}

function h4(block: ContentBlock): Content {
  return { text: block.getText(), fontSize: 10, bold: true }
}

function h5(block: ContentBlock): Content {
  return { text: block.getText(), fontSize: 8, bold: true }
}

function h6(block: ContentBlock): Content {
  return { text: block.getText(), fontSize: 6, bold: true }
}

export default function toPDF(markdown: string): [Content[], Style[]] {
  const state: ContentState = parse(markdown)
  const blocks = state.getBlocksAsArray()
  let opening = true

  const result: Content[] = []
  for (const block of blocks) {
    switch (block.getType()) {
      case 'unstyled':
        result.push(unstyled(block, opening))
        opening = false
        break
      case 'unordered-list-item':
        list(result, block)
        break
      case 'header-one':
        result.push(h1(block))
        break
      case 'header-two':
        result.push(h2(block))
        break
      case 'header-three':
        result.push(h3(block))
        break
      case 'header-four':
        result.push(h4(block))
        break
      case 'header-five':
        result.push(h5(block))
        break
      case 'header-six':
        result.push(h6(block))
        break
      default:
        log.warn(`Unimplemented MD block type : ${block.getType()}`)
    }
  }

  return [result, []]
}
